var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Picking',{attrs:{"id_documento":parseInt(_vm.$route.params.id_documento),"num_documento":_vm.$route.params.num_documento}})
}
var staticRenderFns = []

export { render, staticRenderFns }